import React, { Component } from "react";

import "./SignUpForTrial.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
class SignUpForTrial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      name: "",
      email: "",
      whatsapp: "",
      message: "",
      errors: {},
      isSubmitting: false,
    };
  }

  handleClick = () => {
    this.props.history.push(`/product/trial`);
  };

  render() {
    const { showModal, name, email, whatsapp, message, errors, isSubmitting } =
      this.state;
    const isDisabled = !name || !email || !whatsapp || !message || isSubmitting;

    return (
      <>
        {/* Nút mở modal */}
        <div className="trial-button-container" onClick={this.handleShow}>
          <div
            className="trial-button-circle"
            style={{ backgroundColor: "#ff007f" }}
            onClick={this.handleClick}
          >
            <i
              className="fas fa-rocket trial-icon"
              style={{ color: "#fff" }}
            ></i>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpForTrial)
);
